import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BasePreferencesConfig } from './BasePreferencesConfig';
import PreferenceSlotsConfig from './PreferenceSlotsConfig';

export function PreferencesConfig() {
  const [activeTab, setActiveTab] = useState<'base' | 'slots'>('base');
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          <button
            onClick={() => setActiveTab('base')}
            className={`${
              activeTab === 'base'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
          >
            {t('manager.preferencesConfig.baseTab')}
          </button>
          <button
            onClick={() => setActiveTab('slots')}
            className={`${
              activeTab === 'slots'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
          >
            {t('manager.preferencesConfig.slotsTab')}
          </button>
        </nav>
      </div>

      {activeTab === 'base' ? (
        <BasePreferencesConfig />
      ) : (
        <PreferenceSlotsConfig />
      )}
    </div>
  );
}
